import Shoe from "../pages/ShoeV3.jsx";
import Overview from "../pages/Overview.jsx";
import Quiz from "../pages/QuizV3.js";
import NotificationsPage from "../pages/NotificationsPage.js";
import HowTo from "../pages/HowTo.js";
import Likes from "../pages/Likes.js";
import Discover from "../pages/Discover.js";
import Popular from "../pages/Popular.js";
import ColorwayPage from "../pages/ColorwayPage.js";
import Helper from "../functions/Helper.js";
import UserRating from "../pages/UserRating.js";
import Login from "../pages/Login.js";
import Account from "../pages/Account.js";
import Critic from "../pages/Critic.js";
import User from "../pages/User.js";
import UserReviews from "../pages/UserReviews.js";
import Navigation from "../pages/NavigationV2.js";
import { Outlet } from "react-router-dom";
import querystring from "querystring";
import RouterChanges from "../components/RouterChangesV2.js";
import AdInjector from "../components/AdInjector.js";

import * as React from "react";

const Layout = ({ store }) => {
  return (
    <>
      <RouterChanges urlMapping={store.getState().data.urlMapping} />
      {process.env.NODE_ENV !== "development" && (
        <AdInjector siteId="622f42f8688af31b50b63a81" />
      )}
      <Navigation />

      <Outlet />
    </>
  );
};

const routes = (store, actions, globalData) => [
  {
    path: "shoe-reviews/",
    element: <Layout store={store} />,

    loader: async ({ params, request }) => {
      if (typeof window !== "undefined") {
        return null;
      }
      let queryString = request.url.split("?")[1] ?? "";

      const paginatedDataResponse = await fetch(
        __server__ + "/API/pub/filter?" + queryString,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const paginatedData = await paginatedDataResponse.json();

      const filterObject = querystring.parse(queryString);
      store.dispatch(actions.filterObject(filterObject));
      store.dispatch(actions.initial_data({ ...paginatedData }));

      return {
        filterObject,
        paginatedData,
      };
    },

    children: [
      {
        path: "popular",
        element: <Popular />,
        loader: async () => {
          let popularStyles = await fetch(
            __server__ + "/API/pub/popular_styles?limit=100"
          )
            .then((response) => response.json())
            .then((data) => {
              return data;
            });

          return popularStyles;
        },
      },
      {
        path: "critic",
        element: <Critic />,
      },
      {
        path: "user",
        element: <User />,
      },
      {
        path: "quiz",
        element: <Quiz />,
      },
      {
        path: "discover",
        element: <Discover />,
      },

      {
        path: "notifications",
        element: <NotificationsPage />,
      },
      {
        path: "how-does-it-work",
        element: <HowTo />,
      },
      {
        path: "likes",
        element: <Likes />,
      },
      {
        path: "rating",
        element: <UserRating />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "account",
        element: <Account />,
      },
      {
        path: "user-reviews",
        element: <UserReviews />,
      },

      //mapped urls like nike-basketball-shoes etc.
      ...globalData.urlMapping.map((url) => {
        //path should use regext to get the string between "/shoe-reviews/" and the next "/"
        let path = url.url.split("/shoe-reviews/")[1];

        return {
          path: path,
          element: <Overview />,
        };
      }),

      //Shoe Pages
      ...globalData.overview.map((shoe) => ({
        path: shoe.url,
        element: <Shoe key={shoe.url} url={shoe.url} />,
        loader: async () => {
          if (typeof window !== "undefined") {
            return null;
          }
          let shoeData = await Helper.fetchShoeData(shoe.url.toLowerCase());

          store.dispatch(actions.shoeData(shoeData));

          return { shoeData };
        },
      })),

      //Colorways per Shoe
      ...globalData.overview.map((shoe) => ({
        path: shoe.url + "-colorways",
        element: <ColorwayPage url={shoe.url} />,
        loader: async () => {
          if (typeof window !== "undefined") {
            return null;
          }
          let shoeData = await Helper.fetchShoeData(shoe.url.toLowerCase());

          store.dispatch(actions.shoeData(shoeData));

          return shoeData;
        },
      })),

      {
        path: "*",
        element: <div> 404 </div>,
      },

      {
        index: true,
        element: <Overview />,
      },
    ],
  },
];

/*
const routes = [
  {
    path: "/shoe-reviews",
    component: <div> test </div>,
    exact: true,
    filterObject: true,
  },
  {
    path: "/shoe-reviews(/.*basketball-shoes)?",
    component: Overview,
    exact: true,
    filterObject: true,
  },
  /*{
    path: '/shoe-reviews/*basketball-shoes',
    component: Overview,
    exact:true,
  },
  {
    path: "/shoe-reviews/popular/",
    component: Popular,
    fetchToDo: "popular",
    fetchData: () => {
      return fetch(__server__ + "/API/pub/popular_styles?limit=100")
        .then((response) => response.json())
        .then((data) => {
          return data;
        });
    },
  },
  {
    path: "/shoe-reviews/critic",
    component: Critic,
  },
  {
    path: "/shoe-reviews/user",
    component: User,
  },
  {
    path: "/shoe-reviews/quiz",
    component: Quiz,
  },
  {
    path: "/shoe-reviews/discover",
    component: Discover,
  },
  {
    path: "/shoe-reviews/coupons",
    component: CouponPage,
  },
  {
    path: "/shoe-reviews/notifications",
    component: NotificationsPage,
  },
  {
    path: "/shoe-reviews/how-does-it-work",
    component: HowTo,
  },
  {
    path: "/shoe-reviews/likes",
    component: Likes,
  },
  {
    path: "/shoe-reviews/rating",
    component: UserRating,
  },
  {
    path: "/shoe-reviews/login",
    component: Login,
  },
  {
    path: "/shoe-reviews/account",
    component: Account,
  },
  {
    path: "/shoe-reviews/user-reviews",
    component: UserReviews,
  },

  {
    path: "/shoe-reviews/:shoe_name-colorways",
    component: ColorwayPage,
    fetchToDo: "shoe",
    fetchData: (params) => {
      return Helper.fetchShoeData(params.shoe_name.toLowerCase());
    },
  },

  {
    path: "/shoe-reviews/:shoe_name",
    component: Shoe,
    fetchToDo: "shoe",
    fetchData: (params) => {
      return Helper.fetchShoeData(params.shoe_name.toLowerCase());
    },
  },
];

*/

export default routes;
